import FrontPageEnum from '../../enumerators/front-page.enum'

export default class StrateCityComponent {
    constructor() {
        StrateCityComponent.init()
        StrateCityComponent.onClick()
        StrateCityComponent.modeAuto() // Desktop
        StrateCityComponent.setMinHeight() // Desktop
    }

    static init() {
        if ($(FrontPageEnum.STRATE_CITY).length) {
            const options = {
                root: null,
                threshold: 0.1,
            }

            const handleIntersect = (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        $.ajax({
                            url: IRISCollectionCustomer.ajaxUrl,
                            data: {
                                action: 'get_city_image',
                            },
                            method: 'POST',
                        }).done((response) => {
                            $(FrontPageEnum.STRATE_CITY_IMAGES).html(response)
                            setTimeout(() => {
                                $(FrontPageEnum.STRATE_CITY_IMAGES_WRAPPER).addClass('load')
                            }, 100)
                        })

                        observer.unobserve(entry.target)
                    }
                })
            }

            const observer = new IntersectionObserver(handleIntersect, options)
            document.querySelectorAll(FrontPageEnum.STRATE_CITY).forEach((el) => {
                observer.observe(el)
            })
        }
    }

    static switch(itemActive) {
        const itemActiveContent = itemActive.find(FrontPageEnum.STRATE_CITY_ITEM_CONTENT)

        if (!itemActive.hasClass('active')) {
            let itemActiveHeight = 0

            //Close last items
            $(FrontPageEnum.STRATE_CITY_ITEM).addClass('disable-click')
            $(FrontPageEnum.STRATE_CITY_ITEM).removeClass('active')
            $(FrontPageEnum.STRATE_CITY_IMAGES_ITEM).removeClass('active')
            $(FrontPageEnum.STRATE_CITY_ITEM_CONTENT).animate(
                {
                    height: 0,
                },
                600,
            )

            //calc content height for active item
            itemActive
                .find(FrontPageEnum.STRATE_CITY_ITEM_CONTENT)
                .children()
                .each(function () {
                    itemActiveHeight = itemActiveHeight + $(this).outerHeight(true)
                })

            //Show active item image
            $(`[data-city-image-index="${itemActive.data('city-item-index')}"]`).addClass('active')

            // Open active item
            itemActive.addClass('active')
            $(itemActiveContent).animate(
                {
                    height: itemActiveHeight,
                },
                600,
            )
            $(FrontPageEnum.STRATE_CITY_ITEM).removeClass('disable-click')
        }
    }

    static onClick() {
        $(FrontPageEnum.STRATE_CITY_ITEM).on('click', function () {
            StrateCityComponent.switch($(this))
        })
    }

    static modeAuto() {
        let increment = 1
        const total = $(FrontPageEnum.STRATE_CITY_ITEM).length

        const options = {
            root: null,
            threshold: 0.1,
        }

        const handleIntersect = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //Start auto switch
                    const switchCity = setInterval(() => {
                        StrateCityComponent.switch($(`[data-city-item-index="${increment}"]`))
                        increment++

                        if (increment === total) {
                            increment = 0
                        }
                    }, 7000)

                    //Stop Interval in click
                    $(FrontPageEnum.STRATE_CITY_ITEM).on('click', () => {
                        clearInterval(switchCity)
                    })

                    observer.unobserve(entry.target)
                }
            })
        }

        const observer = new IntersectionObserver(handleIntersect, options)
        if (window.matchMedia('(min-width: 1001px)').matches) {
            document.querySelectorAll(FrontPageEnum.STRATE_CITY).forEach((el) => {
                observer.observe(el)
            })
        }
    }

    static setMinHeight() {
        if (window.matchMedia('(min-width: 1001px)').matches) {
            $(FrontPageEnum.STRATE_CITY).css(
                'min-height',
                $(FrontPageEnum.STRATE_CITY).outerHeight(),
            )
        }
    }
}
